import { Component, OnInit, Input, HostListener, ElementRef } from '@angular/core';
import { StorageHelper } from '../helpers/StorageHelper';
import { ThemeService } from '../theme.service';
import { SearchService } from '../search.service';
import { BaseSearchComponent } from '../classes/BaseSearchComponent';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  providers: [ ThemeService, SearchService ]
})
export class SearchBarComponent extends BaseSearchComponent implements OnInit {

  @Input() placeholder = "";
  @Input() autoFocus = false;
  @Input() itemTypes: Array<string> = [];
  @Input() showMedias = true;
  

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      if (this.elementRef && this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        this.showSuggestions = false;
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  constructor(
    private elementRef: ElementRef,
    protected themeService: ThemeService,
    protected searchService: SearchService
  ) {
    super(themeService, searchService);
  }

  ngOnInit() {
    this.inputValue = this.query;
  }

  itemTypeChanged(itemType){
    this.selectedItemType = itemType;
    StorageHelper.getInstance().save(StorageHelper.keys.searchItemType, this.selectedItemType);
    this.getSuggestions();
  }

}
